import React from 'react';
import { trackEvent } from '../../../shared/analytics';
import { SOLUTIONS_LINKEDIN_URL, solutionsFounder } from '../../../shared/config/solutionsContent';

const FOUNDER_PHOTO_SRC = '/brand/founder/kirill-samorodov.jpg';

/**
 * Founder block — personal-brand trust. Full section after the master video.
 * Pure presentational, shared verbatim by the SPA and the prerendered
 * static twin. All copy lives in `shared/config/solutionsContent.ts`.
 *
 * SPA passes `onAuditClick` (scroll + focus the audit form); the static
 * twin omits it and falls back to an `#delivery-audit` hash link.
 */
export function SolutionsFounderSection({
  onAuditClick,
}: {
  onAuditClick?: () => void;
}): React.ReactElement {
  return (
    <section className="solutions-founder" aria-labelledby="solutions-founder-heading">
      <header className="solutions-section-header solutions-section-header--centered">
        <span className="solutions-section-eyebrow">{solutionsFounder.eyebrow}</span>
        <h2 id="solutions-founder-heading">{solutionsFounder.heading}</h2>
      </header>
      <div className="solutions-founder__layout">
        <img
          className="solutions-founder__photo"
          src={FOUNDER_PHOTO_SRC}
          alt={solutionsFounder.photoAlt}
          width={200}
          height={200}
          loading="lazy"
        />
        <div className="solutions-founder__body">
          {solutionsFounder.body.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          <div className="solutions-founder__actions">
            {onAuditClick ? (
              <button
                type="button"
                className="btn-primary"
                onClick={() => {
                  trackEvent('solutions_founder_cta', { cta: 'audit' });
                  onAuditClick();
                }}
              >
                {solutionsFounder.primaryCta}
              </button>
            ) : (
              <a href="#delivery-audit" className="btn-primary">
                {solutionsFounder.primaryCta}
              </a>
            )}
            <a
              className="solutions-founder__link"
              href={SOLUTIONS_LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                trackEvent('solutions_founder_linkedin_click', { placement: 'section' })
              }
            >
              {solutionsFounder.linkedinCta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
